import { Route } from '@angular/router';
import { AuthGuard } from './core/guards';
import { LoggedPageComponent } from './shared/components';

export const appRoutes: Route[] = [
  { path: '', redirectTo: '/login', pathMatch: 'full' }, // to define

  {
    path: '',
    component: LoggedPageComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'projects',
        loadChildren: () =>
          import('./modules/projects/projects.routes').then(
            (m) => m.projectsRoutes,
          ),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./modules/profile/profile.routes').then(
            (m) => m.profileRoutes,
          ),
      },
    ],
  },

  {
    path: '',
    loadChildren: () =>
      import('./modules/auth/auth.routes').then((m) => m.authRoutes),
  },

  { path: '**', redirectTo: '' }, // to define
];
